import BaseScene from './BaseScene';

export default class GameUI extends BaseScene {
    private score = 0;
    private supply = 0;
    private population = 0;
    private scoreText?: Phaser.GameObjects.Text;
    private populationText?: Phaser.GameObjects.Text;

    constructor() {
        super({key: 'GameUI'});
    }

    public init(data: any) {
        super.init();

        this.score = data.initialScore;
        this.supply = data.initialPlayerSupply;
        this.population = data.initialPlayerPopulation;
        
        // Events
        this.registry.events.on('playerPopulationUpdated', this.updatePopulation, this);
        this.registry.events.on('playerSupplyUpdated', this.updateSupply, this);
        this.registry.events.on('scoreUpdated', this.updateScore, this);
    }

    public create() {
        super.create();

        // Game Mode Adjust
        const gameModeOffsetX = this.getBootloaderScene().globals.gameMode === 'mobile' ? 0 : 370;

        // Game Objects
        this.scoreText = this.add.text(420 + gameModeOffsetX, this.height - 35, this.score.toString())
            .setStyle({
                fontFamily: 'arial',
                color: '#fff',
                fontSize: 22
            })
            .setStroke('#2a2a2a', 3)
            .setOrigin(0.5);
        this.forceSpriteBottomPosition(this.scoreText, 0);

        this.populationText = this.add.text(80 + gameModeOffsetX, this.height - 35, this.population + ' / ' + this.convertNegativeSupplyToInfinite(this.supply))
            .setStyle({
                fontFamily: 'arial',
                color: 'white',
                fontSize: 26
            })
            .setStroke('#2a2a2a', 5)
            .setOrigin(0.5);
        this.forceSpriteBottomPosition(this.populationText, 0);
    }

    private convertNegativeSupplyToInfinite(supply: number): string | number {
        if (supply === -1) {
            return '∞';
        }
        return supply;
    }

    private updatePopulation(populationUpdated: number): void {
        this.population = this.population + populationUpdated;
    }

    private updateSupply(supplyUpdated: number): void {
        this.supply = this.supply + supplyUpdated;
    }

    private updateScore(score: number): void {
        this.score =  Math.max(Math.round(score), 0);
        this.scoreText?.setText(this.score.toString());
    }

    public update(): void {
        this.populationText?.setText(this.population + ' / ' + this.convertNegativeSupplyToInfinite(this.supply));
    }

    public cleanUp(): void {
        super.cleanUp();
        this.registry.events.off('playerPopulationUpdated');
        this.registry.events.off('playerSupplyUpdated');
        this.registry.events.off('score');
    }
}